import * as React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import { AdminMedicineModel } from "../../models/medicine";
import ManufacturerService from '../../services/manufacturerService';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  selectedLangId: number,
  getContent: any
}

interface IState {
}

class MedicineTabInteractionsContent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
    };
  }

  public render() {

    const { medicine } = this.props;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-12">
          <label>Description:</label>
          <Editor

            style={{ width: '100%', height: '300px' }}
            onTextChange={(e) => { this.props.handleChange('description', e.htmlValue) }}
            value={this.props.getContent('description')}
          />
        </div>
      </div>
    )
  }
}

export default MedicineTabInteractionsContent;